import { forwardRef } from "react";

const base =
  "inline-flex min-h-[48px] min-w-[44px] items-center justify-center gap-2 rounded-[8px] py-2 text-center text-sm font-medium leading-5 transition-[color,background-color,border-color,opacity] duration-150 disabled:cursor-not-allowed disabled:opacity-50";

const variants = {
  primary:
    "px-4 bg-ax-strong text-white hover:bg-ax-hover active:bg-ax-pressed active:opacity-[0.92] disabled:hover:bg-ax-strong disabled:active:opacity-50",
  secondary:
    "px-4 border border-ax-border bg-ax-surface text-ax-text hover:bg-ax-bg",
  danger: "px-4 bg-ax-error text-white hover:opacity-90",
  ghost: "text-ax-link hover:underline",
};

export const Button = forwardRef(
  ({ variant = "secondary", busy = false, className = "", type = "button", ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      aria-busy={busy || undefined}
      className={`${base} ${variants[variant]} ${className}`}
      {...props}
    />
  ),
);
Button.displayName = "Button";
